import { VpSelect, VpSelectOption } from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'
import type { ITeamsByStoreId } from '../../../core/models/api/team/team'

interface TeamSelectProps {
  selectedTeamId: string | null
  teams: ITeamsByStoreId[] | undefined
  isLoading: boolean
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void
}

const TeamSelect = ({ selectedTeamId, teams, isLoading, onChange }: TeamSelectProps) => {
  const { t } = useTranslation()
  const hasTeams = !!teams && teams.length > 0

  return (
    <VpSelect
      className="mg-homepage-team"
      name="team"
      aria-label="team choice"
      data-testid="team-select"
      variant="primary"
      size="medium"
      placeholder={t('general.homepage.select-team')}
      value={selectedTeamId}
      onChange={onChange}
      disabled={isLoading || !hasTeams}
      status={isLoading || selectedTeamId ? undefined : 'error'}
    >
      {!isLoading &&
        hasTeams &&
        teams.map(team => (
          <VpSelectOption key={team.id} value={`${team.id}`} data-testid={`team-option-${team.id}`}>
            {team.label}
          </VpSelectOption>
        ))}
    </VpSelect>
  )
}

export default TeamSelect
